module.exports = __webpack_public_path__ + "fromBrideToParents-we-y.85a384aa.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/fromBrideToParents-we-y.jpg
// module id = tgLT
// module chunks = 0